import React, { useEffect, useState } from "react";
import TrainerSummary from '../views/TrainerSummary';
import Checkinreport from '../views/checkinreport';
import Header from './Header';
import LeftPane from './LeftPane';
import CheckInCount from '../views/CheckInCount';
import { MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";
import TransactionSummary from '../views/TransactionSummary';
import PlanSummary from '../views/planSummary';
import SessionSummary from "../views/SessionSummary.js";
import SessionCountRpt from "../views/sessionCountRpt.js";

import SmsReports from "../views/smsReports";
import WhatsAppCampaignReports from "../views/whatsAppCampaignReports";
import RevenueReport from "../views/revenueReports";
import WtsAppNotificationRpts from "../views/wtsAppNotificationRpts";
import ActiveMemberHisory from "./ActiveMembersHistory";
// import NewRevenueReport from "../views/newRevenueReport";
import RenewPrediction from "../views/RenewPrediction";
import ClassCheckinReport from "./classCheckinReport";
import { useAccess } from "../context/AccessContext";
import GuestPassSummary from "../views/GuestPassSummary";
import PinelabsSettlementReport from "../views/PinelabsSettlementReport";

function Reports() {
  let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;

  const { loading, handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("reports")
  console.log(roleAccess, 'roleAccess');
  const [basicActive, setBasicActive] = useState("tab1");

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  useEffect(() => {

    if (plansInfo != null && !plansInfo.feature.checkinreports) {
      setBasicActive("tab6");
    }
  }, []);


  let userInfoInSession = localStorage.getItem("loggedUserInfo") ? true : false;



  return (
    <><>
      <LeftPane isactive="13" />
      <Header />
    </>
      <div className="gym-main gym-main-div rightContent">

        <div className='d-flex '>
          <MDBTabs className="customnavtabs">

            {(plansInfo !== null && plansInfo?.feature?.trainersessionssummary) && roleAccess?.trainersummary !== 0 ? <>
              {userInfoInSession && <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab2")}
                  active={basicActive === "tab2"}
                >
                  Trainer Summary
                </MDBTabsLink>
              </MDBTabsItem>}
            </> : ""}
            {(plansInfo !== null && plansInfo?.feature?.checkinreports) && roleAccess?.checkinreports !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab1")}
                  active={basicActive === "tab1"}
                >
                  Check-In
                </MDBTabsLink>
              </MDBTabsItem>
            </> : ""}
            {roleAccess?.checkincount !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab3")}
                  active={basicActive === "tab3"}
                >
                  Check-In Count
                </MDBTabsLink>
              </MDBTabsItem></> : ""
            }

            {(plansInfo != null && plansInfo?.feature.paymentsummary) && roleAccess?.paymentsummary !== 0 ? <>
              {userInfoInSession && JSON.parse(localStorage.getItem("loggedUserInfo")).role !== "staff" && <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab4")}
                  active={basicActive === "tab4"}
                >
                  Payment Summary
                </MDBTabsLink>
              </MDBTabsItem>}
            </> : ""}
            {(plansInfo != null && plansInfo?.feature?.plansummary) && roleAccess?.plansummary !== 0 ? <>
              {userInfoInSession && JSON.parse(localStorage.getItem("loggedUserInfo")).role !== "staff" &&
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleBasicClick("tab5")}
                    active={basicActive === "tab5"}
                  >
                    Plan Summary
                  </MDBTabsLink>
                </MDBTabsItem>}
            </> : ""}
            {(plansInfo != null && plansInfo?.feature?.sessioncount) && roleAccess?.session !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab6")}
                  active={basicActive === "tab6"}
                >
                  Session
                </MDBTabsLink>
              </MDBTabsItem>
            </> : ""}
            {(plansInfo != null && plansInfo?.feature?.sessionsummary) && roleAccess?.sessionsummary !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab7")}
                  active={basicActive === "tab7"}
                >
                  Session Summary
                </MDBTabsLink>
              </MDBTabsItem>
            </> : ""}
            {roleAccess?.smshistory !== 0 ? <> <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab8")}
                active={basicActive === "tab8"}
              >
                SMS History
              </MDBTabsLink>
            </MDBTabsItem></> : ""}
            {roleAccess?.whatsappcampaignhistory !== 0 ? <> <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab9")}
                active={basicActive === "tab9"}
              >
                WhatsApp Campaign History
              </MDBTabsLink>
            </MDBTabsItem></> : ""}
            {roleAccess?.whatsappnotificationhistory !== 0 ? <> <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab11")}
                active={basicActive === "tab11"}
              >
                WhatsApp Notification History
              </MDBTabsLink>
            </MDBTabsItem></> : ""}
            {(plansInfo != null && plansInfo?.feature?.revenuereport) && roleAccess?.revenuereport !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab10")}
                  active={basicActive === "tab10"}
                >
                  Revenue Report
                </MDBTabsLink>
              </MDBTabsItem>
            </> : ""}
            {(plansInfo != null && plansInfo?.feature?.activememberhistory) && roleAccess?.activemembershistory !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab12")}
                  active={basicActive === "tab12"}
                >
                  Active Members History
                </MDBTabsLink>
              </MDBTabsItem>
            </> : ""}
            {roleAccess?.renewprediction !== 0 ? <>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab13")}
                  active={basicActive === "tab13"}
                >
                  Renewal Prediction
                </MDBTabsLink>
              </MDBTabsItem>

            </> : ""}


            {
              roleAccess?.schedulesummary !== 0 ? <>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleBasicClick("tab14")}
                    active={basicActive === "tab14"}
                  >
                    Schedule Summary
                  </MDBTabsLink>
                </MDBTabsItem>
              </> : ""

            }


            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab15")}
                active={basicActive === "tab15"}
              >
                Guest Pass Summary
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab16")}
                active={basicActive === "tab16"}
              >
                PineLabs Settlement
              </MDBTabsLink>
            </MDBTabsItem>
          </MDBTabs >
        </div >
        <MDBTabsContent>
          <MDBTabsPane open={basicActive === "tab1"} show={basicActive === "tab1"}>
            {basicActive === "tab1" && <Checkinreport roleAccess={roleAccess} />}

          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab2"} show={basicActive === "tab2"}>
            {basicActive === "tab2" && <TrainerSummary roleAccess={roleAccess} />}


          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab3"} show={basicActive === "tab3"}>
            {basicActive === "tab3" && <CheckInCount roleAccess={roleAccess} />}


          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab4"} show={basicActive === "tab4"}>
            {basicActive === "tab4" && <TransactionSummary roleAccess={roleAccess} />}

          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab5"} show={basicActive === "tab5"}>

            {basicActive === "tab5" && <PlanSummary roleAccess={roleAccess} />}

          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab6"} show={basicActive === "tab6"}>

            {basicActive === "tab6" && <SessionSummary roleAccess={roleAccess} />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab7"} show={basicActive === "tab7"}>

            {basicActive === "tab7" && <SessionCountRpt roleAccess={roleAccess} />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab8"} show={basicActive === "tab8"}>


            {basicActive === "tab8" && <SmsReports roleAccess={roleAccess} />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab9"} show={basicActive === "tab9"}>

            {basicActive === "tab9" && <WhatsAppCampaignReports roleAccess={roleAccess} />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab10"} show={basicActive === "tab10"}>

            {basicActive === "tab10" && <RevenueReport />}
            {/* {basicActive === "tab10" && <NewRevenueReport />} */}

          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab11"} show={basicActive === "tab11"}>
            {basicActive === "tab11" && <WtsAppNotificationRpts roleAccess={roleAccess} />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab12"} show={basicActive === "tab12"}>
            {basicActive === "tab12" && < ActiveMemberHisory roleAccess={roleAccess} />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab13"} show={basicActive === "tab13"}>
            <RenewPrediction roleAccess={roleAccess} />
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab14"} show={basicActive === "tab14"}>
            {basicActive === "tab14" && <ClassCheckinReport />}
          </MDBTabsPane>

          <MDBTabsPane open={basicActive === "tab15"} show={basicActive === "tab15"}>
            {basicActive === "tab15" && <GuestPassSummary />}
          </MDBTabsPane>
          <MDBTabsPane open={basicActive === "tab16"} show={basicActive === "tab16"}>
            {basicActive === "tab16" && <PinelabsSettlementReport />}
          </MDBTabsPane>
        </MDBTabsContent>


      </div >

    </>
  );
}

export default Reports;